const formatter = new Intl.NumberFormat("it-IT", {
	style: "currency",
	currency: "EUR",

	// These options are needed to round to whole numbers if that's what you want.
	//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const dateMySql = (date) => {
	return date.toISOString().slice(0, 19).replace("T", " ");
};

const dateIt = (date) => {
	const options = { weekday: "long", day: "numeric", month: "short", year: "numeric" };
	return date.toLocaleDateString("it-IT", options);
};

const formatProductStatus = (status) => {
	let s = status;
	if (status == "confirmed") s = "Da preparare";
	if (status == "preparation") s = "In preparazione";
	if (status == "ready") s = "Pronto";
	if (status == "filled") s = "Completato";
	return <div className={"status-box " + status}>{s}</div>;
};

const getPaymentMethodName = (paymentMethodId) => {
	const paymentMethods = [
		{ id: 1, name: "Contanti" },
		{ id: 2, name: "Carta di credito o Bancomat alla consegna" },
		{ id: 3, name: "Paypal" },
		{ id: 4, name: "Fattura" },
		{ id: 5, name: "Ticket" },
		{ id: 6, name: "Assegno" },
		{ id: 7, name: "Bancasella" },
		{ id: 8, name: "Satispay" },
		{ id: 9, name: "Stripe" },
		{ id: 10, name: "Bonifico Bancario" },
		{ id: 11, name: "Nexi" },
		{ id: 12, name: "Viva Wallet" },
		{ id: 13, name: "Credito Prepagato" },
		{ id: 14, name: "Pagamento Elettronico" },
		{ id: 15, name: "Non riscosso" },
		{ id: 16, name: "Training" },
		{ id: 17, name: "Prepagato Glovo" },
		{ id: 18, name: "Prepagato Deliveroo" },
		{ id: 19, name: "Prepagato Justeat" },
		{ id: 20, name: "Pagamento Elettronico Viva Wallet" },
		{ id: 21, name: "Voucherly" },
		{ id: 22, name: "POS Protocollo 17" },
		{ id: 23, name: "Pagamento Elettronico Dojo" },
	];

	const id = parseInt(paymentMethodId);
	if (isNaN(id)) return "Unknown (a)";
	const paymentMethod = paymentMethods.find((method) => method.id === id);
	return paymentMethod ? paymentMethod.name : "Unknown (b)";
};

const roundNumber = (number, decimals = 2, mode = 1) => {
	if (typeof number !== "number") {
		number = parseFloat(number);
	}
	if (!Number.isFinite(number)) return 0;

	const multiplier = Math.pow(10, decimals);
	let n = number * multiplier;

	if (mode === 1) n = Math.round(n);
	else if (mode === 2) n = Math.ceil(n);
	else if (mode === 3) n = Math.floor(n);

	return parseFloat((n / multiplier).toFixed(decimals));
};

// Hash numerico veloce e deterministico
function hashInt(n) {
	n = Math.imul(n ^ 0x9e3779b9, 0x85ebca6b);
	n = Math.imul(n ^ (n >>> 13), 0xc2b2ae35);
	return (n ^ (n >>> 16)) >>> 0;
}

export function pastelColorFromInt(n) {
	const hash = hashInt(n);

	// Hue: 0–360 (copertura uniforme)
	const h = hash % 360;

	// Saturazione pastello: 45–60
	const s = 45 + ((hash >> 8) % 15);

	// Luminosità pastello: 75–85
	const l = 75 + ((hash >> 16) % 10);

	return hslToHex(h, s, l);
}

function hslToHex(h, s, l) {
	s /= 100;
	l /= 100;

	const k = (n) => (n + h / 30) % 12;
	const a = s * Math.min(l, 1 - l);

	const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

	return (
		"#" +
		[f(0), f(8), f(4)]
			.map((v) =>
				Math.round(v * 255)
					.toString(16)
					.padStart(2, "0")
			)
			.join("")
			.toUpperCase()
	);
}

export default {
	formatter,
	dateMySql,
	dateIt,
	formatProductStatus,
	getPaymentMethodName,
	roundNumber,
	pastelColorFromInt,
};
